export default "__VITE_ASSET__C_r1B$w1__"